import { createRouter, createWebHistory } from "vue-router"
import bus from "./../lib/bus"
// function withRandom(routes) {
//   return routes.map((route) => ({
//     ...route,
//     path: route.meta?.skipRandom ? route.path : `${route.path}/:random?`,
//   }))
// }
const routes = [
  {
    path: "/",
    name: "homepage",
    component: () => import("../views/Home.vue"),
    meta: { skipRandom: true },
  },
  // 充值详情内页
  {
    path: "/pay",
    name: "paypage",
    component: () => import("../views/PayPage.vue"),
  },
  // 充值类目选择页
  {
    path: "/home",
    name: "home",
    redirect: { name: "homepage" }, // 重定向到命名路由
    component: () => import("../views/Home.vue"),
    meta: { skipRandom: true },
  },
  //v1老版本重定向路由
  {
    path: "/homepage",
    name: "homepageold",
    redirect: { name: "homepage" }, // 重定向到命名路由
    component: () => import("../views/Home.vue"),
    meta: { skipRandom: true },
  },
  //我的订单
  {
    path: "/orderpage",
    name: "orderpage",
    component: () => import("../views/OrderPage.vue"),
  },
  // 兑换记录
  {
    path: "/exchangerecord",
    name: "exchangerecord",
    component: () => import("../views/ExChangeRecord.vue"),
  },
  //  积分明细
  {
    path: "/integraldetail",
    name: "integraldetail",
    component: () => import("../views/IntegralDetail.vue"),
  },
  // sdk支付
  {
    path: "/sdk/pay",
    name: "sdkpay",
    component: () => import("../views/SdkPay.vue"),
  },
  // 充值平台支付详情页面（微信支付时使用）
  {
    path: "/gamepaypage",
    name: "gamepaypage",
    component: () => import("../views/GamePayPage.vue"),
  },
  // 青瓷玩家补款页
  {
    path: "/compensate",
    name: "compensate",
    component: () => import("../views/SupplementPage.vue"),
  },
  // 微信小游戏支付页面
  {
    path: "/wechatgamepay",
    name: "wechatgamepay",
    component: () => import("../views/WechatGamePayPage.vue"),
  },
  // 充值中心代付页
  {
    path: "/payforanother",
    name: "payforanother",
    component: () => import("../views/PaymentByOthers.vue"),
  },
  // 积分商城页
  {
    path: "/pointsmall",
    name: "pointsmall",
    component: () => import("../views/PointSMallPage.vue"),
  },
  // 我的仓库
  {
    path: "/warehousepage",
    name: "warehousepage",
    component: () => import("../views/WarehousePage.vue"),
  },
  // 我的地址
  {
    path: "/myaddress",
    name: "myaddress",
    component: () => import("../views/MyAddressPage.vue"),
  },
  // 活动抽奖
  {
    path: "/lotterypage",
    name: "lotterypage",
    component: () => import("../views/LotteryPage.vue"),
  },
  // 积分抽奖活动
  {
    path: "/pointslottery",
    name: "pointslottery",
    // component: () => import("../views/PointsLotteryPage.vue"),
    component: () => import("../views/PointsLotteryThemePage.vue"),
  },
  // 获取url里面的redirect_uri进行urldecode解码后，再进行重定向跳转
  {
    path: "/paycashier",
    name: "paycashier",
    component: () => import("../views/PayCashierPage.vue"),
  },
  //牛丸用户积分迁移
  {
    path: "/nwconvert",
    name: "nwconvert",
    component: () => import("../views/NwConvertSnail.vue"),
    meta: { skipInitGuard: true },
  },
  // 周年锦鲤抽奖
  {
    path: "/anniverlottery",
    name: "anniverlottery",
    component: () => import("../views/AnniversaryLottery.vue"),
  },
  {
    path: "/codeexchange",
    name: "codeexchange",
    component: () => import("../components/codeExchange/codeExchange.vue"),
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  // routes: withRandom(routes), // ← 只改这一行
  routes,
  scrollBehavior() {
    return { top: 0 }
  },
})
router.beforeEach((to, from) => {
  // 记录上一个路由路径，用于埋点追踪
  if (from.name) {
    sessionStorage.setItem("prevRoute", from.name)
    sessionStorage.setItem("prevRoutePath", from.path || "")
  }
  if (to.path == "/" || to.path == "/home") {
    return bus.$emit("clearStatus")
  }
})
export default router
